interface CourseModalTextSource {
  title?: string | null
  instructorName?: string | null
  isMultiInstructor?: boolean | null
  headline?: string | null
  skill?: string | null
}

export const getCourseModalText = ({
  title,
  instructorName,
  isMultiInstructor,
  headline,
  skill,
}: CourseModalTextSource) => ({
  modalTitle: isMultiInstructor && title ? title : instructorName ?? title,
  tagline: headline || skill,
})
